
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import Swal from 'sweetalert2';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import * as XLSX from "xlsx";
import { Location } from '@angular/common';
import { Category, ICategory } from '../../../../../models/category.model';
import { Characteristics, ICharacteristics } from '../../../../../models/characteristics.model';
import { IProductType, ProductType } from '../../../../../models/productType.model';
import { IProduct, Product} from '../../../../../models/product.model';
import { IPostProduct, PostProduct } from '../../../../../models/postProduct.model';
import { environment } from '../../../../../environments/environment';
import { Post } from '../../../../../models/post.model';
import { IWallet } from '../../../../../models/wallet.model';
import { CategoryService } from '../../../../../services/category.service';
import { PostService } from '../../../../../services/post.service';
import { ProductService } from '../../../../../services/product.service';
import { ServiceService } from '../../../../../services/service.service';
import { ShopService } from '../../../../../services/shop.service';
import { UserService } from '../../../../../services/user.service';
import { WalletService } from '../../../../../services/wallet.service';
import { NameValidator } from '../../../validators/name.validator';
import { AuthService } from '../../../../../services/auth.service';
import { ITripExpenseService } from '../../../../../models/tripExpenseService.model';
import { IProductDeliveryZones, ProductDeliveryZones } from '../../../../../models/productDeliveryZones.model';
import { UserZone } from '../../../../../models/userZone.model';
import { IShop, Shop } from '../../../../../models/shop.model';
import { SubProductCharacteristic } from '../../../../../models/subProductCharacteristic.model';
import { SubProduct } from '../../../../../models/subProduct.model';
import { PostSubProduct } from '../../../../../models/postSubProduct.model';
import { ProductPass } from '../../../../../models/productPass.model';
import { EditPassComponent } from './edit-pass/edit-pass.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
declare const $:any;
@Component({
  selector: 'app-pass',
  templateUrl: './pass.component.html',
  styleUrls: ['./pass.component.scss']
})
export class PassComponent implements OnInit {
    // @ts-ignore
  public modalRef: BsModalRef;
  isSeller = false;
  isKahpoo = false;
  search: any;
  validName: any;
  validQuantity: any;
  validPrice: any;
  validAlertStock: any;
  validPhotoSubType: any;
  validCharacteristic: any;
  validCharacteristicValue: any;
  // nom des caractéristiques
  slugNombreAnnoncePublie = "max.post.published";
  slugNombreEmploiPublie = "max.job.post.published";
  slugNombreBoutique = "kahpoo.max.shop";
  slugDureeAnnoncePublie = "duration.post.published.hour";
  slugDureeEmploiPublie = "duration.job.post.published.hour";
  slugAnnonceMiseEnAvant = "max.post.promote";
  slugAnnonceEmploiMiseEnAvant = "max.job.post.promote";
  slugDureeAnnonceMiseEnAvant = "duration.post.promote.hour";
  slugDureeEmploiMiseEnAvant = "duration.job.post.promote.hour";
  slugOrganisationDesPromotions = "max.seller.promotion";
  slugPubliciteSponsoriseAnnonce = "max.post.sponsored";
  slugAnnonceBanniere = "max.post.banner";
  slugEnableGestionAgenda = "enable.seller.agenda.management";
  slugEnableSellerPromotion = "enable.seller.promotion";
  slugPublicationReseauxSociaux = "max.published.social.media";
  slugEnableGestionDesCommandes = "enable.seller.order.management";
  slugEnableStatistiqueClient = "enable.review.customer.statistic";
  slugEnableCampagneCommunicationPromotion = "enable.campaign.promotion";
  slugDureeAbonnement = "duration.subscription.hour";
// fin nom  max.seller.promotion
  shopName!: String
  idShop!: number
  @ViewChild('publication') publication: any | null;
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  @ViewChild('closebutton2') closebutton2;
  photoProduit: string = "";
  validProductPhoto:any;
  // @ts-ignore
  currentShop: Shop = {};
  currentProductSubcribe: Product [] = []
  currentProductSubcribeTmp: Product [] = []
  url_photo: String;
  // @ts-ignore
  currentUser: User = [];
  productQuantity:number = 0;
  subProductCharact: SubProductCharacteristic [] = []
  // @ts-ignore
  currentWallet: IWallet = [];
  selectedSubCategory: any;
  isTrueName = false;
  categories:ICategory[]=[];
  categoryWithGiftCard:ICategory[] = [];
  characteristics:ICharacteristics[]=[];
  productTypes:IProductType[]=[];
  caracteristiquesVariante:any[]=[];
  caracteristiquesVarianteTmp:any[]=[];
  filtred:IProduct[]=[];
  filter = false;
  allProduct:IProduct[]=[];
  allProducts: IProduct[] =[];
  productSubTypeForms:any[] = [];
  allProductsTmp: IProduct[] =[];
  photoProduit1: string = "";
  photoProduit2: string = "";
  photoSousProduit: string = "";
  userShop: any
  //les models
  allProductPosted: any[] = [];
  product: Product = {};
  subProduct: SubProduct = {};
  newpostproduct = new PostProduct();
  newpostSubProduct = new PostSubProduct();
  newPostProd: IPostProduct[] =[];
  productSubTypesSaved:SubProduct[] = [];
  tripExpenseList:ITripExpenseService[]=[];
  productDeliveryZonesList:IProductDeliveryZones[]=[];
  productSubTypesForm: any[] = [];
  productSubTypeCharacteristicsForm:any[] = [];
  showProductSubType = false;
  showProductSubTypeButton = true;
  showCharacteristicProduct = false;
  showProductTripExpense = false;
  productSubtypeArrayTampon: any[] = [];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  isFiltreDate: boolean;
  ishiddenDeliveryDdelay:boolean = false;
  shop: IShop[] = [];
  //user: IUser = [];
  allAUserZones: UserZone[] = [];
  // fin les model
  constructor(private userService: UserService,
              private fb: FormBuilder,
              private router: Router,
              private shopService: ShopService,
              private serviceService: ServiceService,
              private postService: PostService,
              private productService: ProductService,
              private walletService: WalletService,
              private modalService: BsModalService,
              private categoryService: CategoryService,
              private activatedRoute: ActivatedRoute, private authService: AuthService, private location: Location) { }

  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadKahpooShop();
      this.loadSubscriptionProduct()
      this.loadCategory();
      this.loadShop();
    },error=>{
      this.router.navigate(['/login']);
    });
  }

  dateForm = this.fb.group({
    beginDate: ['', Validators.required],
    endDate: ['', Validators.required]
  })

  filterProductsByCategory(products: Product[], categoryName: string): Product[] {
    return products.filter((product) => product.category.name === categoryName);
  }

  filterProductsByCategorySlug(products: Product[], categorySlug: string): Product[] {
    return products.filter((product) => product.category.slug === categorySlug);
  }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  saveQuantity=(val: any)=>{
    let index = parseInt(val.target.value);
    this.productQuantity = Number(index);
    return true;
  }

  seuilProd = 0;
  testSeuilProd=false;
  subProductFormDis=false;
  productFormDis=false;
  saveSeuil=(val: any)=>{
    let index = parseInt(val.target.value);
    this.seuilProd = Number(index);
    if(this.seuilProd > this.productQuantity){
      this.testSeuilProd = true;
      this.productFormDis = true;
    }else{
      this.testSeuilProd = false;
      this.productFormDis = false;
    }
  }

  // loadCategory= () => {
  //   this.categoryService.query(0,200).subscribe((data :any)=>{
  //     data.content.forEach((element:any) => {
  //       this.categories.push(element);
  //       console.log("Liste des catégories...");
  //       console.log(this.categories);
  //     });
  //   })
  // };

  loadCategory= () => {
    this.categoryService.query(0,200).subscribe((data :any)=>{
      this.categories = data.content
    })
  };

  loadSubCategory=(val: any)=>{
    let index = parseInt(val.target.value);
    this.productService.getProductCategorySubType(Number(index)).subscribe(
      data=>{
        this.productTypes = data;
        // console.log(this.productTypes)
      }
    )
  }



  selectCategorie(val: any):number{
    let index = val.target.value;
    this.selectedSubCategory = val.target.value;
    this.productService.getProductSubtypeCharacteristic(index).subscribe(rs=>{
      // console.log("¤¤¤¤¤¤¤¤¤¤¤¤¤")
      // console.log(rs);
      this.characteristics = rs;
    })
    this.showCharacteristicProduct = true;
    return index;
  }


  get getProduit() { return this.produitForm.controls; }

  // produitForm = this.fb.group({
  //   name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
  //   category: new FormControl('', Validators.required),
  //   product_type: new FormControl('', Validators.required),
  //   quantity: new FormControl('', [Validators.required,NameValidator.checkOnlyNumberValidator, Validators.maxLength(7),Validators.pattern('^[1-9][0-9]*$')]),
  //   threshold: new FormControl('', [Validators.required,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //   price: new FormControl('',[Validators.required,Validators.minLength(3),Validators.maxLength(8),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  // });


  private loadKahpooShop() {
    this.shopService.kahpooShop().subscribe(rs => {
      this.currentShop = rs;

      this.postService.getAllPostProductPassByShopId(this.currentShop?.shopID).subscribe(data => {
        this.allProductPosted = data;

       // console.log("this.allProductPosted ", this.allProductPosted )
      });

      //console.log("Current shop.....")
      //console.log(this.currentShop)
      // //this.isKahpoo = this.currentUser.kahpoo;
      // this.serviceService.getIdServiceByShop(this.currentShop.id).subscribe(dt => {
      //   //console.log(dt);
      //   // @ts-ignore
      //   this.currentShop.services = dt.content;
      // });
      // this.productService.getIdProductByShop(this.currentShop.id).subscribe((products: any) => {

      //   // this.currentShop.products = dt;
      //   this.currentShop.products = this.filterProductsByCategorySlug(products, "kahpoo-abonnement");


      // });

    });
  }

   loadSubscriptionProduct() {
    this.productService.loadSubscribeProduct(this.pageNumber-1, this.pageSize).subscribe(rs => {
      this.currentProductSubcribe = rs.content;
      this.totalItems = rs.totalElements;
      this.currentProductSubcribeTmp = rs.content;
     // console.log("Current product subscribe.....")
     // console.log(this.currentProductSubcribe)
    });
  }

  onViewWallet(wallet: IWallet) {
    this.currentWallet = wallet;
  }

  disableButtonValider = false;
  // onFormSubmit(){
  //   this.validProductPhoto = this.photoProduit;
  //   let newproduit= new Product();
  //   if(this.produitForm.valid && !this.isTrueName && !this.msg00){
  //     if(this.photoProduit != ''){
  //       this.disableButtonValider = true;

  //       newproduit.name=this.produitForm.controls['name'].value;
  //       newproduit.category=this.getCategory(this.produitForm.controls['category'].value);
  //       newproduit.quantity=this.produitForm.controls['quantity'].value;
  //       newproduit.threshold=this.produitForm.controls['threshold'].value;
  //       newproduit.price=this.produitForm.controls['price'].value;
  //       newproduit.product_type=this.getSubCategory(this.produitForm.controls['product_type'].value);
  //       newproduit.photo=this.photoProduit;
  //       newproduit.shop=this.currentShop;
  //       // console.log("newproduit-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_")
  //       // console.log(newproduit)
  //       this.productService.saveProduct(newproduit).subscribe( rs=>{
  //         this.produitForm.reset();
  //         this.disableButtonValider = false;
  //         this.reloadComponent();
  //         document.getElementById("btnCloseModalEditProduct")?.click();
  //         this.produitForm.reset();
  //         this.loadKahpooShop();
  //         Swal.fire({
  //           position: 'top-end',
  //           icon: 'success',
  //           title: 'Votre produit a été enregistré avec succès.',
  //           showConfirmButton: false,
  //           timer: 1500
  //         });
  //         }, error => {
  //           this.disableButtonValider = false;
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'error',
  //             title: 'Erreur d\'ajout <br>'+error.error.errorMessage,
  //             showConfirmButton: false,
  //             timer: 1500
  //           })
  //         });

  //     }else{
  //       Swal.fire({
  //         position: 'top-end',
  //         icon: 'error',
  //         title: 'Vous devez ajouter au minimum une photo pour votre produit.',
  //         showConfirmButton: false,
  //         timer: 4000
  //       });
  //       newproduit = new Product();
  //     }
  //   }else{
  //     Swal.fire({
  //       position: 'top-end',
  //       icon: 'error',
  //       title: 'Veuillez renseigner les champs obligatoires s\'il vous plaît.',
  //       showConfirmButton: false,
  //       timer: 5000
  //     });
  //   }
  // }

  getCategory(id:any) :Category {
    let category:Category = new Category();
    this.categories.forEach(element => {
      if(element.id == id) {
        category = element;
      }
    })
    return category;
  }

  getSubCategory(id:any) :IProductType {
    let product_type:ProductType = new ProductType();
    this.productTypes.forEach(element => {
      if(element.id == id) {
        product_type = element;
      }
    })
    return product_type;
  }

  // Only AlphaNumeric
  keyPressAlphanumeric(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (!/[!@#$%°£§^&*$()_+\=\[\]{};:"\\|,.<>\/?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }

  }

  /**
   * Rechercher si le vendeur a déjà un produit en ce nom
  */

  getIfProductNameExist(nameTampon?: any): boolean {
    let testName = nameTampon.target.value;
    let testbool = false; // Initialisez à false car vous ne savez pas encore si le nom existe
    for (const element of this.currentProductSubcribe) {
      if (element.name && element.name.toUpperCase() === testName.toUpperCase()) {
        // Si un produit avec le même nom est trouvé, mettez testbool à true et sortez de la boucle
        testbool = true;
        break;
      }
    }
    // Mettez à jour isTrueName selon la valeur de testbool
    this.isTrueName = testbool;
    return testbool;
  }



  readFile(event: any) {
    this.whenClickForChangeImage = true;
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      // console.log("file :"+file);
      const reader = new FileReader();
      reader.onload = (readEvent: any) => {
        // console.log("url"+readEvent.target.result);
        this.photoProduit= readEvent.target.result;
        this.validProductPhoto = this.photoProduit;
      };
      reader.readAsDataURL(file);
    }
  }

  currentProduct: Product;
  onViewProduct(prod: any) {
    this.productService.getIdProduct(prod.id).subscribe(product =>  {
      this.currentProduct = product;
      this.subProductCharact = this.currentProduct.subProducts[0].subProductCharacteristics
      //console.log("Détails produit.....");
      //console.log(this.currentProduct);
      //console.log("Détails subProductCharact.....");
      //console.log(this.subProductCharact);
    });
  }

  updatedProduct: Product;
  whenClickForChangeImage : boolean = false;
  editProduct(prod: Product){
    this.categoryService.query(0,200).subscribe((data :any)=>{
      data.content.forEach((element:any) => {
        this.categories.push(element);
      });
      // console.log("Liste des catégories...");
      // console.log(this.categories);
    })
    this.productService.getProductCategorySubType(Number(prod?.category?.id)).subscribe(
      data=>{
        this.productTypes = data;
      }
    )
    this.updatedProduct = prod;
   // console.log("Updated product")
   // console.log(this.updatedProduct)
    this.photoProduit = this.url_photo + prod.photo;
    this.produitForm.patchValue({
      id: prod.id,
      name: prod.name,
      category: prod.category.id,
      product_type: prod.product_type.id,
      quantity: prod.quantity,
      threshold: prod.threshold,
      price: prod.price
    })
  }

  onSubmitEditForm(): void {

    if(!this.msg00){
      let produit         = new Product();
      produit.id          = this.updatedProduct.id;
      produit.productID   = this.updatedProduct.productID;
      produit.available   = this.updatedProduct.available;
      produit.createdAt   = this.updatedProduct.createdAt;
      produit.product_type= undefined;

      produit.name        = this.produitForm.controls['name'].value;
      produit.price       = this.produitForm.controls['price'].value;
      produit.quantity    = this.produitForm.controls['quantity'].value;
      produit.threshold   = this.produitForm.controls['threshold'].value;
      produit.category    = this.getCategory(this.produitForm.controls['category'].value);
      produit.product_type= this.getSubCategory(this.produitForm.controls['product_type'].value);

      this.whenClickForChangeImage == false ?  produit.photo="" : produit.photo=this.photoProduit;

      produit.shop=this.updatedProduct.shop;

      // console.log("🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥 Produit Envoyé ! 🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥")
      // console.log(produit);
      this.productService.updateProduct(produit).subscribe(rs=>{
        this.close1();
        this.reloadComponent();
        this.produitForm.reset();
        this.whenClickForChangeImage = false;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Les informations du Forfait ont été modifiés avec succès.',
          showConfirmButton: false,
          timer: 3000
        });
      }, error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Une erreur est survenue sur l\'édition du produit ! <br>'+error.error.errorMessage,
          showConfirmButton: false,
          timer: 3000
        })
      });
    }
  }

  //ça permet d'actualiser le composant
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  deleteProduit(prod:IProduct){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer ce produit ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.productService.deleteProduct_new(prod).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre Forfait est supprimé de la liste avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadKahpooShop();
            this.reloadComponent();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 5500
            })
          }
        )
      }
    })

  }

  msg00!:string;
  test00=false;
  url00: any;
  selectFile00(event: any) {
    var mimeType = event.target.files[0].type;
    var sizeFile=event.target.files[0].size;
    if(!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg00 = 'Selectionner une photo';
    }
    // console.log("size!!!!!")
    // console.log(sizeFile)
    if(sizeFile<2000000){
      // console.log(mimeType);
      if (mimeType=="image/jpeg"||mimeType=="image/jpg"||mimeType=="image/png") {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "";
          this.test00 = true;
          // alert(this.test)
          this.url00 = reader.result;
          this.photoProduit = this.url00;
          // console.log( this.url00);
        }
      }else{

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "Ce type de fichier n'est pas pris en compte.";
          this.url00 = reader.result;
          this.test00 = false;
        }
      }
    }else{
      // this.msg = "la taille de l'image est trop grande";
      var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "La taille de l'image est trop grande";
          this.url00 = reader.result;
          this.photoProduit = this.url00;
          this.test00 = false;
          // console.log( this.url00)
        }
    }
  }

  // openFile()
  // {
  //   $('#photo_produit').click();
  // }

  strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}

  publishProduct(p: Product) {
    let alreadyPublished = false;
    this.allProductPosted.forEach(pp => {
      if(p.productID === pp.postSubProducts[0].subProduct.productID){
        alreadyPublished = true;
      }
      if(alreadyPublished){
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: 'Oups! ce forfait a été déjà mise en annonce',
          showConfirmButton: false,
          timer: 5500
        });
        return;
      }
    });

    if(alreadyPublished === false){
        this.publication.show();
        this.product = p;
    }
  }

  postForm = this.fb.group({
    price: new FormControl('', [ Validators.required,Validators.minLength(3), Validators.maxLength(10), NameValidator.checkOnlyNumberValidator ]),
    description: new FormControl('',[Validators.minLength(10),Validators.maxLength(255)])
  });

  postFormEdit = this.fb.group({
    price: new FormControl('', [ Validators.required,Validators.minLength(3), Validators.maxLength(10), NameValidator.checkOnlyNumberValidator ]),
    description: new FormControl('',[Validators.minLength(10),Validators.maxLength(255)])
  });

  model = {
    description: ''
  };

  get post() { return this.postForm.controls; }




  onFormSubmitPass(): void{

    if(this.postForm.valid){
        this.newpostSubProduct.subProduct = this.product.subProducts[0];

        let newpost= new Post();
        newpost.title=this.product.name;
        newpost.description=this.postForm.controls['description'].value;
        newpost.vip=false;
        newpost.allowPaymentOnShipping = false;
          this.newpostSubProduct.allowDelivery = false;
          this.newpostSubProduct.deliveryDelay="";
          this.newpostSubProduct.unitDeliveryDuration = "";
          this.newpostSubProduct.pickFormShop = true;
          this.newpostSubProduct.price=this.postForm.controls['price'].value;
        // this.newpostproduct.allowDelivery= newpost.allowDelivery;
       // this.newpostproduct.allowPaymentOnShipping= newpost.allowPaymentOnShipping;
        //console.log(this.newpostproduct)
        this.newPostProd.push(this.newpostSubProduct);
        newpost.postSubProducts = this.newPostProd;
        // console.log("👉️👉️👉️👉️👉️NOUVELLE ANNONCE")
        //console.log("newpost", newpost)
        //newpost.userID = this.userShop
        this.postService.savePostBack(newpost).subscribe( rs=>{
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Votre annonce est en attente de validation.',
            showConfirmButton: false,
            timer: 3500
          });
          this.clear();
          // window.setTimeout(() => {
          //   window.location.reload()
          // }, 1000);
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 1500
          })
        })
    }
  }
  onFormEditPass(): void{

    if(this.postFormEdit.valid){
        this.newpostSubProduct.subProduct = this.currentProduct.subProducts[0];

        let newpost= new Post();
        newpost.title = this.currentProduct.name;
        newpost.description=this.postFormEdit.controls['description'].value;
        newpost.vip=false;
        newpost.allowPaymentOnShipping = false;
          this.newpostSubProduct.allowDelivery = false;
          this.newpostSubProduct.deliveryDelay="";
          this.newpostSubProduct.unitDeliveryDuration = "";
          this.newpostSubProduct.pickFormShop = true;
          this.newpostSubProduct.price=this.postFormEdit.controls['price'].value;
        // this.newpostproduct.allowDelivery= newpost.allowDelivery;
       // this.newpostproduct.allowPaymentOnShipping= newpost.allowPaymentOnShipping;
        //console.log(this.newpostproduct)
        this.newPostProd.push(this.newpostSubProduct);
        newpost.postSubProducts = this.newPostProd;
        // console.log("👉️👉️👉️👉️👉️NOUVELLE ANNONCE")
        //console.log("newpost", newpost)
        //newpost.userID = this.userShop
        this.postService.updatePost(newpost).subscribe( rs=>{
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Votre annonce est en attente de validation.',
            showConfirmButton: false,
            timer: 3500
          });
          this.clearEdit();
          // window.setTimeout(() => {
          //   window.location.reload()
          // }, 1000);
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 1500
          })
        })
    }
  }

  clearEdit()
  {
    this.postFormEdit.patchValue({
      price: [],
      description: []
    });
    this.publication.hide();
    this.loadKahpooShop();
  }

  clear()
  {
    this.postForm.patchValue({
      price: [],
      description: []
    });
    this.publication.hide();
    this.loadKahpooShop();
  }

  // ajout des catégorie
  onFormSubmit(): void{
    if(!this.isTrueName){
      let newproduit= new Product();
      if(this.productSubTypesSaved.length>0){
        if(this.produitAndVarianteForm.controls.produitAndVarianteForm0.invalid){
          this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAllAsTouched();
          this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAsUntouched();
          this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
          return;
        }else{
          //let productSubTypeCharacteristicsForm = this.produitAndVarianteForm.controls['produitAndVarianteForm1'].value;
          this.tripExpenseList = this.produitAndVarianteForm.controls['tripExepense'].value;
          this.tripExpenseList.forEach(element => {
            if(element.tripExpense && element.price){
              let productDeliveryZones = new ProductDeliveryZones();
              productDeliveryZones.userZone = this.getUserZone(element.tripExpense);
              productDeliveryZones.price = element.price;
              this.productDeliveryZonesList.push(productDeliveryZones);
            }
          });
          let productInitForm = this.produitAndVarianteForm.controls['produitAndVarianteForm0'].value;

          newproduit.name = productInitForm.name;
          newproduit.category = this.getCategory(productInitForm.category);
          newproduit.product_type=this.getSubCategory(productInitForm.product_type);
          //newproduit.shop=this.getShop(productInitForm.shop);
          newproduit.shop=this.getShop(this.idShop);

          newproduit.subProducts=this.productSubTypesSaved;
          // newproduit.tripExpenseProducts=this.myTripExpense;
          newproduit.productDeliveryZones=this.productDeliveryZonesList;
          this.productService.saveProductBack(newproduit).subscribe(rs=>{
            // console.log("Produit enregistrer")
            // console.log(rs)

            this.disableButtonValider = false;
            document.getElementById("btnCloseModalEditProduct")?.click();
            this.produitForm.reset();
            this.loadProduct_v1();
            this.reloadComponent();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre Forfait a été enregistré avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
          }, error => {
            this.disableButtonValider = false;
            newproduit= new Product();
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur d\'ajout <br>'+error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          });
        }
      }else{
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veuillez dabord vérifier les caractéristiques du produit.',
          showConfirmButton: false,
          timer: 5000
        });
      }
    }
  }
  //  onlyLettersAndNumbersPattern = /^[a-zA-Z0-9]*$/;
  produitAndVarianteForm1 = this.fb.group({
    name: new FormControl('', Validators.required),
    characteristic_value: new FormControl('', [ Validators.required,Validators.minLength(1),NameValidator.checkValidOnlyLetterOrNumber]),
  })
  // Définissez votre modèle d'expression régulière pour accepter uniquement les lettres et les chiffres
//  onlyLettersAndNumbersPattern = /^[a-zA-Z0-9]*$/;

// // Initialisez votre FormGroup avec les validateurs requis
//   produitAndVarianteForm1 = this.fb.group({
//   name: new FormControl('', Validators.required),
//   characteristic_value: new FormControl('', [
//     Validators.required,
//     Validators.minLength(1),
//     Validators.pattern(this.onlyLettersAndNumbersPattern) // Ajoutez le validateur de modèle avec l'expression régulière
//   ])
// });

  produitAndVarianteForm = this.fb.group({
    produitAndVarianteForm0: this.fb.group({
      // name: new FormControl('',{ validators: nameProductValidator('Le nom', 2, 50), updateOn: 'change'} ),
      name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
      category: new FormControl('', Validators.required),
      product_type: new FormControl('', Validators.required),
      shop: new FormControl('', Validators.required),
    }),

    produitAndVarianteForm1: this.fb.group({
      name: new FormControl('', Validators.required),
      characteristic_value: new FormControl('', [ Validators.required,Validators.minLength(1),NameValidator.checkValidOnlyLetterOrNumber]),
    }),

    produitAndVarianteForm2: this.fb.group({
      quantity: new FormControl('', [ Validators.required,Validators.minLength(1),Validators.maxLength(8),NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
      price: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(10),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$') ]),
      threshold: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
    }),

    tripExepense: this.fb.array([]) ,
  });

  openFile(){
    $('#photo_produit').click();
  }


  /* Vérifier si les valeurs des champs sont valides */
  /*¤¤¤¤¤¤¤¤¤¤ Validation du premier formulaire ¤¤¤¤¤¤¤¤¤¤¤¤*/
  get testName() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.name');}
  get testCategorie() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.category');}
  get testProductType() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.product_type');}
  get testShop() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.shop');}
  /*¤¤¤¤¤¤¤¤¤¤ ---------------------------- ¤¤¤¤¤¤¤¤¤¤¤¤*/

  /*¤¤¤¤¤¤¤¤¤¤ Validation du deuxième formulaire ¤¤¤¤¤¤¤¤¤¤¤¤*/
  get testCaracteristiqueName() {return this.produitAndVarianteForm.get('produitAndVarianteForm1.name');}
  get testCaracteristiqueValue() {return this.produitAndVarianteForm.get('produitAndVarianteForm1.characteristic_value');}
  /*¤¤¤¤¤¤¤¤¤¤ ---------------------------- ¤¤¤¤¤¤¤¤¤¤¤¤*/

  /*¤¤¤¤¤¤¤¤¤¤ Validation du troisième formulaire ¤¤¤¤¤¤¤¤¤¤¤¤*/
  get testQuantity() {return this.produitAndVarianteForm.get('produitAndVarianteForm2.quantity');}
  get testPrice() {return this.produitAndVarianteForm.get('produitAndVarianteForm2.price');}
  get testThreshold() {return this.produitAndVarianteForm.get('produitAndVarianteForm2.threshold');}
  /*¤¤¤¤¤¤¤¤¤¤ ---------------------------- ¤¤¤¤¤¤¤¤¤¤¤¤*/

  removeProductCharacteristics(i:number): void {
    if(i >= 0 && i < this.caracteristiquesVariante.length){
      this.caracteristiquesVariante.splice(i,1);
      this.caracteristiquesVarianteTmp = this.caracteristiquesVariante;
      this.caracteristiquesVariante = [...this.caracteristiquesVariante];
    }

  }

  getUserZone(id:any) : UserZone{
    let userzone : UserZone = new UserZone();
    this.allAUserZones.forEach(element => {
      // console.log(element.zone?.id + "==" + id)
      if(element?.id == id) {
        userzone = element;
      }
    })
    return userzone;
  }

  getShop(id:any) :Shop {
    let myshop:Shop = new Shop();
    this.shop.forEach(element => {
      if(element.id == id) {
        myshop = element;
      }
    })
    return  myshop;
  }

  loadProduct_v1 = () => {
    this.allProduct= [];
    this.filtred = [];
    this.productService.loadProduct_v1(0,200).subscribe((data :any)=>{
      // console.log("Liste des produits");
      // console.log(data.content);
      this.allProducts = data.content;
      this.allProductsTmp = data.content;
    })
  };

  // loadShop = () => {
  //   this.shopService.query(0, 200).
  //   subscribe((data) => {
  //     data.content.forEach((element: any) => {
  //       this.shop.push(element);
  //     });
  //   })
  // };

  loadShop = () => {
    this.shopService.kahpooShop().
    subscribe((data) => {
      this.shop.push(data);
      this.shopName = this.shop[0].name
      this.idShop = this.shop[0].id
      this.userShop = this.shop[0].sellerId
      this.shop.forEach(el => {
      //  console.log(el)
      })
    })
  };

  saveProductSubTypeAndCaracteristique(){
    this.validProductPhoto = this.photoProduit;
    if(this.validProductPhoto != ''){
      let subProduct = new SubProduct()
      if(this.produitAndVarianteForm.controls.produitAndVarianteForm0.invalid){
        this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAllAsTouched();
        this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAsUntouched();
        this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
        return;
      }else{
        if(this.produitAndVarianteForm.controls.produitAndVarianteForm2.invalid){
          this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAsUntouched();
          this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAsUntouched();
          this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAllAsTouched();
          return;
        }else{
          let productInitForm = this.produitAndVarianteForm.controls['produitAndVarianteForm0'].value;
          let productSubTypeForms = this.produitAndVarianteForm.controls['produitAndVarianteForm2'].value;
          if(this.productSubTypeForms != null){

            subProduct.photoTampon = this.photoProduit;
            subProduct.photo = this.photoProduit;
            if(this.photoProduit1){
              subProduct.photo1 = this.photoProduit1;
            }
            if(this.photoProduit2){
              subProduct.photo2 = this.photoProduit2;
            }
            subProduct.name = productInitForm.name;
            subProduct.price = productSubTypeForms.price;
            subProduct.quantity = productSubTypeForms.quantity;
            subProduct.threshold = productSubTypeForms.threshold;
            subProduct.subProductCharacteristics = this.caracteristiquesVariante;
           // console.log("productSubTypeForms", productSubTypeForms)
           // console.log("caracteristiquesVariante", this.caracteristiquesVariante)
            let subProductCharacteristic =  subProduct.subProductCharacteristics
            if (!this.verifCharacteristic(subProductCharacteristic)) {
              return; // Stop execution if there is an error in characteristics verification
           }
            this.productSubTypesSaved.push(subProduct);
            this.caracteristiquesVarianteTmp = [];
          }
         // this.caracteristiquesVariante = [];
          //this.photoProduit = "";
         // this.photoProduit1 = "";
         // this.photoProduit2 = "";
         // this.produitAndVarianteForm?.get('produitAndVarianteForm2')?.reset();
         this.showSweetSuccess()
        }
      }
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez ajouter une photo s\'il vous plaît.',
        showConfirmButton: false,
        timer: 2500
      });
    }
  }

  saveProductCarateristics(){
    let sbProdCharact:any[]=[];
    let isAllreadySaved = false;
    if(this.caracteristiquesVariante.length >0){
      if(this.produitAndVarianteForm.controls.produitAndVarianteForm1.invalid){
        this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAsUntouched();
        this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
        this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAllAsTouched();
        return;
      }else{
        let productSubTypeCharacteristicsForm = this.produitAndVarianteForm.controls['produitAndVarianteForm1'].value;
        this.caracteristiquesVarianteTmp.forEach(element => {
          if(element.characteristic.id === Number(productSubTypeCharacteristicsForm.name)){
            isAllreadySaved = true;
          }
        });
        if(isAllreadySaved){
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Vous avez déjà ajouté cette caractéristique',
            showConfirmButton: false,
            timer: 2500
          })
        }else{
          if(this.productSubTypeCharacteristicsForm != null){
            // console.log(" Test valuesssss ");
            // console.log(this.caracteristiquesVarianteTmp);
            let sbProductCharacteristic = new SubProductCharacteristic();
            let characteristic = new Characteristics();
            characteristic.characteristic_value = productSubTypeCharacteristicsForm.characteristic_value;
            sbProductCharacteristic.characteristic = this.getCharacteristic(productSubTypeCharacteristicsForm.name);
            sbProductCharacteristic.value = productSubTypeCharacteristicsForm.characteristic_value;
            sbProdCharact.push(sbProductCharacteristic);
            this.caracteristiquesVariante.push(sbProductCharacteristic);
            this.caracteristiquesVarianteTmp.push(sbProductCharacteristic);
            this.addProductSubType();
            this.produitAndVarianteForm?.get('produitAndVarianteForm1')?.reset()
          }
          // console.log("Caractéristique du formulaire d'ajout de produit")
          // console.log(this.caracteristiquesVariante);
        }
      }
    }else{
      // Si c'est la première caractéristique ajoutée
      if(this.produitAndVarianteForm.controls.produitAndVarianteForm1.invalid){
        this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAsUntouched();
        this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
        this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAllAsTouched();
        return;
      }else{
        let productSubTypeCharacteristicsForm = this.produitAndVarianteForm.controls['produitAndVarianteForm1'].value;

        if(this.productSubTypeCharacteristicsForm != null){
          let sbProductCharacteristic = new SubProductCharacteristic();
          let characteristic = new Characteristics();
          characteristic.characteristic_value = productSubTypeCharacteristicsForm.characteristic_value;
          sbProductCharacteristic.characteristic = this.getCharacteristic(productSubTypeCharacteristicsForm.name);
          sbProductCharacteristic.value = productSubTypeCharacteristicsForm.characteristic_value;
          sbProdCharact.push(sbProductCharacteristic);
          this.caracteristiquesVariante.push(sbProductCharacteristic)
          this.caracteristiquesVarianteTmp.push(sbProductCharacteristic);
          this.addProductSubType();
          // Remove product subtype characteristique
          // if(this.productSubTypeCharacteristicsForm.length>=1){
          //   for(let i in this.productSubTypeCharacteristicsForm){
          //     this.showCharacteristicProduct = true;
          //     this.productCharacteristics.removeAt(Number(i));
          //   }
          // }
          this.produitAndVarianteForm?.get('produitAndVarianteForm1')?.reset()
        }
        // console.log("Caractéristique du formulaire d'ajout de produit")
        // console.log(this.caracteristiquesVariante);
      }
    }

  }
  disabledSavedProduct = false;
  addProductSubType() {
    this.showProductSubType = true;
    this.showProductSubTypeButton = false;
    this.productProductSubTypes.push(this.newProductSubType());
    this.disabledSavedProduct = true;
  }
  getCharacteristic(id:any) :Characteristics {
    let  characteristic:Characteristics = new Characteristics();
    this.characteristics.forEach(element => {
      if(element.id == id) {
        characteristic = element;
      }
    })
    return characteristic;
  }

  newProductSubType(): FormGroup {
    return this.fb.group({
      name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
      quantity: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
      price: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(10),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$') ]),
      threshold: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
    })
  }
  produitForm = this.fb.group({
    name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
    category: new FormControl('', Validators.required),
    product_type: new FormControl('', Validators.required),
    shop: new FormControl('', Validators.required),
    quantity: new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.maxLength(7), Validators.pattern('^[1-9][0-9]*$')]),
    // threshold: new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
    // price: new FormControl('',[Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(8),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
    // deliveryDelay: new FormControl('', Validators.required),
    // unitDeliveryDuration: new FormControl('', Validators.required),
    productCharacteristics: this.fb.array([]) ,
    productProductSubTypes: this.fb.array([]) ,
    tripExepense: this.fb.array([]) ,
  });

  get  productCharacteristics() : FormArray {
    return this.produitForm.get("productCharacteristics") as FormArray
  }
  get  productSubTypescharacteristique() : FormArray {
    return this.produitForm.get("productSubTypescharacteristique") as FormArray
  }
  get productProductSubTypes() : FormArray {
    return this.produitForm.get("productProductSubTypes") as FormArray
  }
  get tripExepense() : FormArray {
    return this.produitAndVarianteForm.get("tripExepense") as FormArray
  }


  loadShopCategory = (val:any)=>{
    let index = parseInt(val.target.value);
    let shopName: IShop;
    this.shopService.getIdShop(index).subscribe(rs=>{
      shopName = rs;
      if(shopName.name=="Kahpoo".toLowerCase() && shopName.id == index){
        this.loadCategory();
      }else{
        this.loadCategoryWithoutGiftCard();
      }
    })
  }


  changeName(val){
    let index = val.target.value;
    if(index && index !=''){
      this.validName = '';
    }
  }
  changeQuantity(val){
    let index = val.target.value;
    if(index && index !=''){
      this.validQuantity = '';
    }
  }
  changePrice(val){
    let index = val.target.value;
    if(index && index !=''){
      this.validPrice = '';
    }
  }
  changeAlertStock(val){
    let index = val.target.value;
    if(index && index !=''){
      this.validAlertStock = '';
    }
  }

  loadCategoryWithoutGiftCard= () => {
    this.categories = [];
    this.categoryWithGiftCard = [];
    let categoriesTampon:any[] = [];
    this.categoryService.query(0,200).
    subscribe((data :any)=>{
      data.content.forEach((element:any) => {
        categoriesTampon.push(element);
      });
      categoriesTampon.forEach(element => {
        this.categoryWithGiftCard.push(element);
      });
      for(let index in this.categoryWithGiftCard){
        if(this.categoryWithGiftCard[index].name==="Carte cadeaux"){
          this.categoryWithGiftCard.splice(Number(index),1);
          this.categoryWithGiftCard = [...this.categoryWithGiftCard];
        }
      }
      this.categories = this.categoryWithGiftCard;
    })
  };

  mettreatrue  = false;
  testRequiredValue(){
    this.mettreatrue = true;
  }
  newtripexepense(): FormGroup {
    return this.fb.group({
      tripExpense:new FormControl('', Validators.required),
      price: new FormControl('',[Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(10),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
    })
  }
  isRequiredZone = false;
  isRequiredPrice = false;
  addtripexepense() {
    if(this.allAUserZones.length > 0) {
      this.isRequiredZone = true;
      this.isRequiredPrice = true;
      this.showProductTripExpense = true;
      this.tripExepense.push(this.newtripexepense());
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Vous devez définir préalablement la liste des zones que vous couvrez dans votre boutique.',
        showConfirmButton: false,
        timer: 3500
      });
    }
  }


//   editProductSubscribe(prod: Product) {
//     this.modalRef = this.modalService.show(EditPassComponent,{
//         initialState: { prod },
//         class: 'modal-dialog modal-xl', // Vous pouvez utiliser 'modal-lg' pour un modal large
//         backdrop: false,
//         ignoreBackdropClick: true
//     });
// }

editProductSubscribe(prod: Product) {
  const modalRef: BsModalRef = this.modalService.show(EditPassComponent, {
      initialState: { prod },
      class: 'modal-dialog modal-xl',
      backdrop: false,
      ignoreBackdropClick: true
  });

  // Passer la référence du modal au composant parent
  modalRef.content.closeModal.subscribe(() => {
      modalRef.hide(); // Fermer le modal lorsque l'événement pour le fermer est émis
  });
}

verifCharacteristic(array: any[]): boolean {

  let maxJobPostPromoteFound = false;
  let durationJobPostPromoteHourFound = false;
  let maxPostPublished = false
  let durationPostPublishedHourFound = false;
  let durationSubscriptionHourFound = false
  let maxPostPromoteFound = false;
  let durationPostPromoteHourFound = false;
  array.forEach(characteristic => {
      if (characteristic.characteristic.name === this.slugAnnonceEmploiMiseEnAvant) {
          maxJobPostPromoteFound = true;
      }
       if (characteristic.characteristic.name === this.slugDureeEmploiMiseEnAvant) {
          durationJobPostPromoteHourFound = true;
      }
      if (characteristic.characteristic.name === this.slugAnnonceMiseEnAvant) {
        maxPostPromoteFound = true;
    }
    if (characteristic.characteristic.name === this.slugDureeAnnonceMiseEnAvant) {
      durationPostPromoteHourFound = true;
  }
      if (characteristic.characteristic.name === this.slugNombreAnnoncePublie) {
        maxPostPublished = true;
      }
      if (characteristic.characteristic.name === this.slugDureeAnnoncePublie) {
        durationPostPublishedHourFound = true;
      }
      if (characteristic.characteristic.name === this.slugDureeAbonnement) {
        durationSubscriptionHourFound = true;
      }


  });

  // Vérifier les conditions et afficher un message d'erreur si nécessaire
  if (maxJobPostPromoteFound && !durationJobPostPromoteHourFound) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'Erreur : max.job.post.promote est présent dans la liste, mais duration.job.post.promote.hour ne l\'est pas.',

    });
    return false

  } if (!maxJobPostPromoteFound && durationJobPostPromoteHourFound) {

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'Erreur : duration.job.post.promote.hour est présent dans la liste, mais max.job.post.promote ne l\'est pas.',

    });
    return false
  }
  if (maxPostPromoteFound && !durationPostPromoteHourFound) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'Erreur : max.post.promote est présent dans la liste, mais duration.post.promote.hour ne l\'est pas.',

    });
    return false

  }
  if (!maxPostPromoteFound && durationPostPromoteHourFound) {

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'Erreur : duration.post.promote.hour est présent dans la liste, mais max.post.promote ne l\'est pas.',

    });
    return false
  }

  if (maxPostPublished && !durationPostPublishedHourFound) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'Erreur : '+this.slugNombreAnnoncePublie+' est présent dans la liste, mais '+ this.slugDureeAnnoncePublie + ' ne l\'est pas.',

    });

    return false
  } if (!maxPostPublished && durationPostPublishedHourFound) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'Erreur : '+ this.slugDureeAnnoncePublie +' est présent dans la liste, mais' +this.slugNombreAnnoncePublie+ ' ne l\'est pas.',

    });

    return false
  }

  if (!durationSubscriptionHourFound) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'Erreur : '+ this.slugDureeAbonnement +' n\'est pas présent dans la liste des catactéristiques',

    });

    return false
  }

  return true
}
characteristicValueType: string
updateInputType(even: any) {

  const selectedCharacteristicId = (event.target as HTMLSelectElement).value;  // Récupérer l'ID de la caractéristique sélectionnée
  const selectedCharacteristic = this.characteristics.find(ch => ch.id.toString() === selectedCharacteristicId); // Trouver la caractéristique correspondante dans votre liste
  const selectedCharacteristicName = selectedCharacteristic ? selectedCharacteristic.name : ''; // Récupérer le nom de la caractéristique
  if (selectedCharacteristicName.startsWith('max') || selectedCharacteristicName.startsWith('duration') || selectedCharacteristicName.includes('kahpoo.max.shop') ) {
    this.characteristicValueType = 'number';
  } else if (selectedCharacteristicName.startsWith('enable')) {
    this.characteristicValueType = 'select';
  } else {
    this.characteristicValueType = 'text';
  }
}

getTranslatedValue(value: string, name: string): string {
  if (!value && value !== "0") {
    return "0"; // Si la valeur est vide ou non définie, afficher "zéro"
  }
  if (value !== undefined) {
    let valueCharacteristic: number = parseInt(value);
    // Effectuer la conversion en fonction du nom de la caractéristique
      let durationInHours: number
      let durationInDays: number
      let durationInMonths: number
    if (name !== undefined) {
       if( (name.includes(this.slugDureeAbonnement) || name.includes(this.slugDureeAnnoncePublie) || name.includes(this.slugDureeAnnonceMiseEnAvant) || name.includes(this.slugDureeEmploiPublie) || name.includes(this.slugDureeEmploiMiseEnAvant)) && valueCharacteristic >=24 ) {
       durationInHours = valueCharacteristic;
       durationInDays = Math.round(durationInHours / 24);
       durationInMonths = Math.round(durationInDays / 1);
    return `${durationInMonths} Jour(s)`;
   }else if( (name.includes(this.slugDureeAbonnement) || name.includes(this.slugDureeAnnoncePublie) || name.includes(this.slugDureeAnnonceMiseEnAvant) || name.includes(this.slugDureeEmploiPublie) || name.includes(this.slugDureeEmploiMiseEnAvant)) && valueCharacteristic < 24 ) {
    durationInHours = valueCharacteristic;
    durationInDays = Math.round(durationInHours / 24);
    durationInMonths = Math.round(durationInDays / 1);
  return `${durationInHours} Heure(s)`;
  } else if (name.includes(this.slugEnableGestionAgenda)) {
        if (valueCharacteristic !==0){
          return "Oui"
        }
        return "Oui";

      }else if (name.includes(this.slugEnableSellerPromotion)) {
        if (valueCharacteristic !==0){
          return "Oui"
        }
        return "Oui";

      } else if (name.includes(this.slugEnableGestionDesCommandes)) {
        if (valueCharacteristic !==0){
          return "Oui"
        }
        return "Non";
      }else if (name.includes(this.slugEnableStatistiqueClient)) {
        if (valueCharacteristic !==0){
          return "Oui"
        }
        return "Non";
      }else if (name.includes(this.slugAnnonceBanniere) && valueCharacteristic === 0) {
        return "0";
      }else if (name.includes(this.slugPubliciteSponsoriseAnnonce) && valueCharacteristic === 0) {
        return "0";
      } else if (name.includes(this.slugOrganisationDesPromotions)) {
        if (valueCharacteristic !==0){
          return "Oui"
        }
        return "Non";
      } else if (name.includes(this.slugEnableCampagneCommunicationPromotion)) {
        if (valueCharacteristic !==0){
          return "Oui"
        }
        return "Non";
      } else if (name.includes(this.slugAnnonceMiseEnAvant) && valueCharacteristic === 0) {
        return "0";
      } else {
        return value; // Retourne la valeur telle quelle si aucune conversion n'est nécessaire
      }
    }
  }

  return "0"; // Valeur par défaut si la valeur n'est pas définie ou si la conversion ne s'applique pas
}

showSweetSuccess() {
  Swal.fire({
    title: "Success",
    text: "Caractéristiques verifiées avec succès",
    icon: "success"
  });
}

raiseTableSize(event: any) {
  this.pageSize = event.target.value;
 // console.log(" this.pageSize ",  this.pageSize )
  this.loadSubscriptionProduct();
}

exportPostToExelFile(filename: string) {
  const data = document.getElementById('tab-post');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */
  XLSX.writeFile(wb, filename);
}

pagination(){
  if(this.isFiltreDate){
    this.filterByDate()
  }
  else{
    this.loadSubscriptionProduct()
  }

}

beginDateVal: any = null;
displayErrorMessage: boolean = false;
getBeginDate(event: any) {
  this.beginDateVal = event.target.value;
  if(this.beginDateVal != null){
    this.disableEndDate = false;
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else {
      this.displayErrorMessage = false;
    }
  }
}

endDateVal: any = null;
disableEndDate: boolean = true;
getEndDate(event: any) {
  this.endDateVal = event.target.value;
  //console.log(this.endDateVal);
  if(this.beginDateVal > this.endDateVal){
    this.displayErrorMessage = true;
  }else{
    this.displayErrorMessage = false;
  }
}

refresh() {
  this.loadSubscriptionProduct();
  this.dateForm.patchValue({
    beginDate: '',
    endDate: ''
  })
}

filterByDate() {
  const beginDate = this.dateForm.get('beginDate').value;
  const endDate = this.dateForm.get('endDate').value;

  // Vérifier si les deux champs de date sont vides
  if (!beginDate || !endDate) {
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'Veuillez renseigner la date de début et la date de fin',
      showConfirmButton: false,
      timer: 3500
    });
    return;
  } else {
    const beginDateISO = new Date(beginDate).toISOString();
    const endDateISO = new Date(endDate).toISOString();
    // console.log("Date sélectionnée")
    // console.log('beginDate:', beginDateISO);
    // console.log('endDate:', endDateISO);

    this.productService.loadSubscribeProductByDate(beginDateISO, endDateISO, this.pageNumber - 1, this.pageSize).subscribe(data => {
      this.currentProductSubcribe = data.content;
      this.totalItems = data.totalElements;
      this.isFiltreDate = true
    });
  }
}

searchProducts($event: KeyboardEvent) {
   // console.log("this.products", this.currentProductSubcribe)
    this.currentProductSubcribe = this.currentProductSubcribeTmp.filter(value =>

      value?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.productID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.category?.name?.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.city?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.city?.country?.iso.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.sellerId?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.sellerId?.lastname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.address.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      (Number(this.search) === Number(value?.shop?.mobile))
    )
    //this.totalItems = this.currentProductSubcribe.length
  }

  ascendingByProductName: boolean = true;
  sortByProductName(){
    this.currentProductSubcribe.sort((a, b) => {
      const nameA = a.subProducts[0].name.toLowerCase();
      const nameB = b.subProducts[0].name.toLowerCase();

      if(this.ascendingByProductName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingByProductName = !this.ascendingByProductName;
  }

  ascendingByProductID: boolean = true;
  sortByProductID(){
    this.currentProductSubcribe.sort((a, b) => {
      const nameA = a?.productID;
      const nameB = b?.productID;
      if(this.ascendingByProductID){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingByProductID = !this.ascendingByProductID;
  }

  ascendingByCategorie: boolean = true;
  sortByCategorie(){
    this.currentProductSubcribe.sort((a, b) => {
      const nameA = a.category.name.toLowerCase();
      const nameB = b.category.name.toLowerCase();

      if(this.ascendingByCategorie){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingByCategorie = !this.ascendingByCategorie;
  }

  ascendingByCreatedDate: boolean = true;
  sortByCreatedDate() {
    this.currentProductSubcribe.sort((a, b) => {
      const dateA = new Date(a.subProducts[0].createdAt);
      const dateB = new Date(b.subProducts[0].createdAt);
      if(this.ascendingByCreatedDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingByCreatedDate = !this.ascendingByCreatedDate;
  }


}
